import React, { useState, useEffect } from 'react';
import { DURATION_PRE, DURATION_MAX } from './globals'; // Import everything from utils


const ZoomBar = ({ onZoomChange }) => {
  // Initial range values
  const [zoomValue, setZoomValue] = useState(DURATION_PRE);

  useEffect(() => {
    // Call the callback when zoom value changes
    onZoomChange(zoomValue);
  }, [zoomValue, onZoomChange]);

  const handleChange = (event) => {
    setZoomValue(Number(event.target.value));
   
  };
  const increaseZoom = () => {
    setZoomValue((prev) => Math.min(prev + 60000, DURATION_MAX)); // Increment by 1 minute
  };

  const decreaseZoom = () => {
    setZoomValue((prev) => Math.max(prev - 60000, DURATION_PRE)); // Decrement by 1 minute
  };

  return (
    <div style={{ width: '100%', padding: '10px' }}>
      
      <input
        id="zoom-slider"
        type="range"
        min={DURATION_PRE}
        max={DURATION_MAX}
        step={1000}
        value={zoomValue}
        onChange={handleChange}
        className='zoomSlider' 
      />
    </div>
  );
};

export default ZoomBar;
